'use strict';

var React = require('react');
var functions = require('../../../helpers/functions.js');
require('../../forms/Address/Autocomplete.js');
require('../../forms/Address/Option.js');
require('../../forms/Checkbox/component.js');
require('../../forms/CustomFormatInput/component.js');
require('../../forms/DateInput/component.js');
require('../../forms/EmailInput/component.js');
require('../../forms/FileInput/component.js');
require('../../forms/FormFeedback/component.js');
require('../../forms/FormField/component.js');
require('../../forms/FormLabel/component.js');
var component = require('../../forms/Input/component.js');
require('../../forms/NumberInput/component.js');
require('../../forms/PatternInput/component.js');
require('../../forms/PhoneInput/component.js');
require('../../forms/Radio/component.js');
require('../../forms/ReadOnlyControl/component.js');
require('../../forms/Select/Control.js');
require('../../forms/Select/Option.js');
require('../../forms/Select/multi-select/OptionMulti.js');
require('../../forms/Select/multi-select/ControlMulti.js');
require('../../forms/Switch/component.js');
require('../../forms/TextArea/component.js');
require('../../forms/TextInput/component.js');
require('../../forms/UrlInput/component.js');
var component$1 = require('../../Icon/component.js');
require('../../Tooltip/component.js');
var filterPopin_styles = require('./filterPopin.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const FilterInputPopin = ({ id, node = { current: null }, queryParam, colKey, isPopinRightSide = false, $top, $left, addToQueryParams = functions.noop, removeFromQueryParams = functions.noop, searchPlaceholder = 'Rechercher', defaultOrder = 'date', labelOrderTitle = 'Option de tri', labelOrderDate = 'Tri désactivé', labelOrderAsc = 'Trier de A \u2192 Z', labelOrderDesc = 'Trier de Z \u2192 A', orderingDisabled, searchMinRequiredChars = 3, }) => {
    const [searchValue, setSearchValue] = React.useState(queryParam?.key === colKey && queryParam?.search ? queryParam.search : '');
    const [sortValue, setSortValue] = React.useState(queryParam?.key === colKey && queryParam?.order ? queryParam.order : defaultOrder);
    const onSortBy = (param) => {
        removeFromQueryParams({ key: colKey });
        if (param.search !== '' || param.order !== defaultOrder) {
            addToQueryParams({ ...param, key: colKey });
        }
    };
    const onInputChange = (e) => {
        const val = e.target.value === undefined || e.target.value === null ? '' : e.target.value;
        setSearchValue(val);
        if (val === '' || val.length >= searchMinRequiredChars) {
            onSortBy({ search: val, order: sortValue });
        }
    };
    const makeOnRadioChange = (order) => (e) => {
        setSortValue(e.target.value);
        onSortBy({ search: searchValue, order });
    };
    return (React__default.default.createElement(filterPopin_styles.ContainerStyled, { id: id, ref: node, isPopinRightSide: isPopinRightSide, "$top": $top, "$left": $left },
        React__default.default.createElement(component.Input, { autoFocus: true, id: `${id}-search`, placeholder: searchPlaceholder, value: searchValue, onChange: onInputChange, prefix: React__default.default.createElement(component$1.Icon, { name: "search-filled", size: "m" }) }),
        !orderingDisabled && (React__default.default.createElement(React__default.default.Fragment, null,
            React__default.default.createElement(filterPopin_styles.FilterDiv, null, labelOrderTitle),
            React__default.default.createElement(filterPopin_styles.FlexDiv, null,
                React__default.default.createElement(filterPopin_styles.Radio, { id: `${id}-date`, name: "filter", value: "date", checked: sortValue === 'date', onChange: makeOnRadioChange('date') }),
                React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-date` }, labelOrderDate)),
            React__default.default.createElement(filterPopin_styles.FlexDiv, null,
                React__default.default.createElement(filterPopin_styles.Radio, { id: `${id}-asc`, name: "filter", value: "asc", checked: sortValue === 'asc', onChange: makeOnRadioChange('asc') }),
                React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-asc` }, labelOrderAsc)),
            React__default.default.createElement(filterPopin_styles.FlexDiv, null,
                React__default.default.createElement(filterPopin_styles.Radio, { id: `${id}-desc`, name: "filter", value: "desc", checked: sortValue === 'desc', onChange: makeOnRadioChange('desc') }),
                React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-desc` }, labelOrderDesc))))));
};

exports.FilterInputPopin = FilterInputPopin;
//# sourceMappingURL=filterInputPopin.js.map
